import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, ArrowRight } from 'lucide-react';

const FadeInSection = ({ children }) => {
  const [isVisible, setVisible] = useState(false);
  const domRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    const { current } = domRef;
    observer.observe(current);

    return () => observer.unobserve(current);
  }, []);

  return (
    <div
      className={`transition-all duration-1000 ease-out transform ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
      }`}
      ref={domRef}
    >
      {children}
    </div>
  );
};

const Malerservice = () => {
  return (
    <div className="py-12 md:py-16 relative overflow-hidden">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative z-10">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 uppercase tracking-tighter">Malerservice</h1>
        <p className="text-gray-500 text-lg md:text-xl max-w-2xl mb-12">Professionelt malerarbejde udført med sans for detaljen og fokus på kvalitet.</p>
        
        <div className="grid grid-cols-1 gap-12 md:gap-16">
          <div className="scroll-mt-32">
            <FadeInSection>
              <div className="flex flex-col lg:flex-row gap-8 md:gap-16 items-center">
                <div className="w-full lg:flex-1">
                  <img 
                    src="https://assets.auxodev.dk/assets/09a255bd-240d-4146-9576-7ce8e0751aeb/7bf6af18-8791-4521-90ba-6c12e1690586.jpg" 
                    alt="Malerservice" 
                    className="w-full h-80 sm:h-96 md:h-[750px] object-cover object-top shadow-lg" 
                  />
                </div>
                <div className="w-full lg:flex-1">
                  <span className="text-emerald-600 font-bold text-sm uppercase tracking-widest mb-3 block">
                    Malerarbejde inde og ude
                  </span>
                  <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">Malerservice</h2>
                  <p className="text-gray-500 text-base md:text-lg leading-relaxed mb-8">
                    Hos Alssund Rengøring får du professionelt malerarbejde udført af uddannede malere med over 20 års erfaring i faget. Vi leverer indvendigt og udvendigt malerarbejde med fokus på grundigt forarbejde, høj kvalitet og et flot resultat, der holder.
                  </p>
                  <ul className="space-y-3 mb-10">
                    {[
                      'Afrensning af tapet',
                      'Fuldspartling af vægge og lofter',
                      'Opsætning af tapet',
                      'Maling af vægge og lofter',
                      'Maling af træværk',
                      'Udvendig maling af facade og træværk'
                    ].map(item => (
                      <li key={item} className="flex items-start gap-3 text-gray-700 font-medium text-sm md:text-base">
                        <CheckCircle2 className="text-emerald-600 shrink-0 mt-0.5" size={18} /> {item}
                      </li>
                    ))}
                  </ul>
                  <Link to="/kontakt" className="inline-flex items-center gap-2 border-b-2 border-emerald-600 pb-1 text-emerald-700 font-bold hover:gap-4 transition-all text-sm md:text-base">
                    Book malerservice <ArrowRight size={18} />
                  </Link>
                </div>
              </div>
            </FadeInSection>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Malerservice;
